<div
    [style.mask]="'url(/assets/images/'+ icon +'.svg) no-repeat center / contain'"
    [style.-webkit-mask]="'url(/assets/images/'+ icon +'.svg) no-repeat center / contain'"
    [style.padding]="padding"
    [style.background-color]="color"
    [matTooltip]="tooltip"
>
</div>
